import styled from 'styled-components';

const StyledReferralToAnalyticalExaminationForm = styled.form`
   display: grid;
   grid-gap: 24px;
   grid-auto-rows: max-content;
   width: 100%;
`;

StyledReferralToAnalyticalExaminationForm.displayName = 'StyledReferralToAnalyticalExaminationForm';

export { StyledReferralToAnalyticalExaminationForm };
